"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cookie_1 = __importDefault(require("cookie"));
var ManagerConfiger_1 = __importDefault(require("../manager/ManagerConfiger"));
var ManagerShare = (function () {
    function ManagerShare() {
        this.wxSdkAddress = 'https://static.qianliaowang.com/sdk/jwx-1.3.0.js';
        this.wxConfigAddress = "/" + ManagerConfiger_1.default.domain + "/api/js-sdk/wx?actions=hide_all&__date&normal=1";
        this.csrfKey = '_csrf';
        this.secCsrfValue = '_secCsrfValue';
        this.queuedScripts = [];
    }
    ManagerShare.prototype.init = function (props, callback) {
        if (callback === void 0) { callback = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var responseText, wxObj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.onReadyCallback = callback;
                        return [4, this.executeLoad(this.wxSdkAddress)];
                    case 1:
                        _a.sent();
                        return [4, this.loadScriptByXHR(this.generateSigntureUrl(this.wxConfigAddress))];
                    case 2:
                        responseText = _a.sent();
                        return [4, this.monitorWXReady(responseText)];
                    case 3:
                        wxObj = _a.sent();
                        return [2, wxObj];
                }
            });
        });
    };
    ManagerShare.prototype.loadScriptByXHR = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        _this.load(url, resolve, false);
                    })];
            });
        });
    };
    ManagerShare.prototype.load = function (url, onload, order) {
        var iQueue = this.queuedScripts.length;
        if (order) {
            var qScript = {
                response: null,
                onload: onload,
                done: false,
            };
            this.queuedScripts[iQueue] = qScript;
        }
        var xhrObj = this.getXHRObj();
        xhrObj.onreadystatechange = function () {
            if (xhrObj.readyState === 4) {
                if (onload) {
                    onload(xhrObj.responseText);
                }
                else {
                    console.log('on load null');
                }
            }
        };
        xhrObj.open('GET', url, true);
        xhrObj.send('');
    };
    ManagerShare.prototype.getXHRObj = function () {
        var methods = [
            function () {
                return new XMLHttpRequest();
            },
        ];
        return methods[0]();
    };
    ManagerShare.prototype.generateSigntureUrl = function (wxConfigAddress) {
        if (window && window.document && window.document.cookie) {
            var options = cookie_1.default.parse(window.document.cookie || '');
            if (options &&
                options[this.csrfKey] &&
                options[this.secCsrfValue]) {
                return wxConfigAddress + "&c1=" + options[this.csrfKey] + "&c2=" + options[this.secCsrfValue];
            }
            else {
                return wxConfigAddress;
            }
        }
        return wxConfigAddress;
    };
    ManagerShare.prototype.monitorWXReady = function (responseText) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        var wxObj = window.wx;
                        if (wxObj) {
                            try {
                                var wxConfig = JSON.parse(responseText);
                                console.log('拿到分享配置 ', wxConfig);
                                if (wxConfig && wxConfig.data) {
                                    wxObj.config(wxConfig.data);
                                    wxObj._wxAppId = wxConfig.data.appId;
                                    resolve(wxObj);
                                }
                            }
                            catch (error) {
                                console.log('WX Ready onError', error);
                            }
                            wxObj.ready(function () {
                                'undefined' === typeof window ||
                                    navigator.userAgent.match(/WindowsWechat/i) ||
                                    wxObj.hideAllNonBaseMenuItem();
                                console.log('WX Ready.');
                            });
                        }
                        else {
                            reject("Error: wx object doesn't exit");
                        }
                    })];
            });
        });
    };
    ManagerShare.prototype.executeLoad = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2, new Promise(function (resolve, reject) {
                        _this.loadJS(url, function () {
                            resolve();
                        });
                    })];
            });
        });
    };
    ManagerShare.prototype.loadJS = function (url, callback) {
        var script = document.createElement('script');
        var fn = callback;
        script.type = 'text/javascript';
        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState === 'loaded' ||
                    script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    fn();
                }
            };
        }
        else {
            script.onload = function () {
                fn();
            };
        }
        script.src = url;
        script.defer = true;
        script.async = true;
        script.crossOrigin = 'anonymous';
        document.body.appendChild(script);
    };
    return ManagerShare;
}());
exports.default = new ManagerShare();
//# sourceMappingURL=ManagerShare.js.map